import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService, CoursesService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import {Location} from '@angular/common';

@Component({
    selector: 'da-teaser-box',
    templateUrl: './teaser-box.component.html',
    styleUrls: ['./teaser-box.component.scss'],
    standalone: false
})
export class TeaserBoxComponent implements OnInit {
    @Input() data: any;
    @Input() portal: string = null;
    public countryCode: string;
    public isPartnerPage: boolean;
    public portalId: string;

    constructor(
        private _configurationService: ConfigurationService,
        private _router: Router,
        private _coursesService: CoursesService,
        private _localizeRouterService: LocalizeRouterService,
        private location: Location
    ) {}

    ngOnInit() {
        this.portalId = this._configurationService.portalId;
    }

    goToCateogryOverview() {
        window.location.href = this.data.link;
    }

    goToCoursesPage(categoryName) {
        this.isPartnerPage = this._configurationService.isPartnerPage();
        if (this.isPartnerPage) {
            this._coursesService.getAllPortalCourses(this.portal).then(
                (courses) => {
                    this.doStuffIfCategories(categoryName, courses.categories);
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            this._coursesService.getAllCourses().then(
                (courses) => {
                    this.doStuffIfCategories(categoryName, courses.categories);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }

    doStuffIfCategories(categoryName, categories) {
        categories.filter((data) => {
            const _site = this._configurationService.getCurrentSite();
            const currentPortal = this._configurationService.portalId;
            if (categoryName && data) {
                const isPortal = this._configurationService.isPartnerPage();
                if (data.name.toLowerCase().replaceAll(' ', '') === categoryName.toLowerCase()) {
                    if (isPortal) {
                        const lang = JSON.parse(sessionStorage.getItem('portalLang')).lang
                            ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                            : '';

                        sessionStorage.setItem(`selectedValue${currentPortal}${lang}`, data.id);
                        sessionStorage.removeItem(`selectedSubCatValue${currentPortal}${lang}`);
                        sessionStorage.removeItem(`selectedSubSubCatValue${currentPortal}${lang}`);
                    } else {
                        sessionStorage.setItem(`selectedValue${_site}`, data.id);
                        sessionStorage.removeItem(`selectedSubCatValue${_site}`);
                        sessionStorage.removeItem(`selectedSubSubCatValue${_site}`);
                    }
                }
            } else {
                sessionStorage.removeItem(`selectedValue${_site}`);
                sessionStorage.removeItem(`selectedValue${currentPortal}`);
            }
        });
    }
    }
